import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import FormContext from './FormContext';

/**
Componente per raggruppare componenti di input.

Per eseguire una validazione della form, utilizzare il metodo `valida()` della reference.

_Nota: se usate gli hooks vedi `useFormState` per la gestione dello stato, vedi `useForm` per la gestione del contesto delle form._

 */
class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validare: false,
    };

    this.validationState = {};
    this.subscriptions = {};
    this.errori = {};
    this.struttura = {};
    this.isValid = true;
  }

  addToForm = (name, value, callback) => {
    this.validationState[name] = value;
    this.errori[name] = [];
    this.subscriptions[name] = callback;
    this.struttura.All = (this.struttura.All || []).concat(name);

    this.rivalida();
  };

  removeFromForm = (name) => {
    delete this.validationState[name];
    delete this.errori[name];
    delete this.subscriptions[name];
    const position = this.struttura.All.indexOf(name);
    if (~position) { // eslint-disable-line no-bitwise
      this.struttura.All.splice(position, 1);
    }

    this.rivalida();
  };

  resetta = () => {
    this.setState({
      validare: false,
    });
    Object.keys(this.subscriptions).forEach((prop) => prop != null
      && this.subscriptions[prop] != null && this.subscriptions[prop]());
  };

  // API pubblica
  // eslint-disable-next-line react/no-unused-class-component-methods
  valida = () => {
    this.setState({
      validare: true,
    });
    return this.isValid;
  };

  rivalida = () => {
    const { onValidationChange } = this.props;
    let nuovaValidità = true;

    Object.keys(this.validationState).forEach((x) => {
      nuovaValidità = nuovaValidità && this.validationState[x];
    });
    if (this.isValid !== nuovaValidità) {
      this.isValid = nuovaValidità;

      if (onValidationChange) {
        setTimeout(() => onValidationChange(this.isValid));
      }
    }
  };

  updateValidationState = (field, isValid, messages) => {
    const { onChange } = this.props;
    this.validationState[field] = isValid;

    const uguali = (this.errori[field] || []).length === messages.length
      && (this.errori[field] || []).every((v, i) => v === messages[i]);
    if (!uguali) {
      this.errori[field] = messages;
      setTimeout(() => onChange({ FormErrors: this.errori }));
    }

    this.rivalida();
  };

  render() {
    const {
      children,
      className,
      onChange,
      stato,
    } = this.props;
    const {
      validare,
    } = this.state;

    const classes = cns(
      'form',
      className,
    );

    return (
      <FormContext.Provider value={{
        addToForm: this.addToForm,
        isValid: this.updateValidationState,
        onFormChange: onChange,
        removeFromForm: this.removeFromForm,
        resetta: this.resetta,
        stato,
        validare,
      }}
      >
        <div className={classes}>
          {children}
        </div>
      </FormContext.Provider>
    );
  }
}

Form.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /**
   * Callback invocata al cambiamento del valore di un input della form:
   * ```
   *  onChange({ ...updates,  FormErrors: errori })
   * ```
   * dove:
   * * *errori*: elenco degli errori associati ai fields della form
   * * *updates*: sono i campi modificati.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Callback invocata al cambiamento dello stato di validazione della form:
   * ```
   *  onValidationChange(isValid)
   * ```
   * dove:
   * * *isValid*: validità della form
   */
  onValidationChange: PropTypes.func,
  /**
Oggetto con coppie nome:valore a cui vengono bindati i campi della form (vedi proprietà name dei componenti di input).
  */
  stato: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

Form.defaultProps = {
  children: null,
  className: '',
  onValidationChange: null,
};

export default Form;
